/* eslint-disable max-len */
import 'react';

function TopThree(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <defs>
                <linearGradient
                    x1="16.993%"
                    y1="41.443%"
                    x2="82.955%"
                    y2="57.326%"
                    id="prefix_three__c"
                >
                    <stop stopColor="#8CDCFF" offset="0%" />
                    <stop stopColor="#ABC9FF" offset="100%" />
                </linearGradient>
                <linearGradient
                    x1="23.641%"
                    y1="6.682%"
                    x2="76.317%"
                    y2="87.087%"
                    id="prefix_three__f"
                >
                    <stop stopColor="#54CAFF" offset="0%" />
                    <stop stopColor="#3A80FF" offset="100%" />
                </linearGradient>
                <linearGradient
                    x1="61.073%"
                    y1="100%"
                    x2="38.927%"
                    y2="0%"
                    id="prefix_three__j"
                >
                    <stop stopColor="#FFF" stopOpacity={0.664} offset="0%" />
                    <stop stopColor="#FFF" offset="51.127%" />
                </linearGradient>
                <linearGradient
                    x1="48.351%"
                    y1="44.94%"
                    x2="50%"
                    y2="100%"
                    id="prefix_three__k"
                >
                    <stop stopColor="#49AAFF" stopOpacity={0} offset="0%" />
                    <stop stopColor="#8CBBFF" offset="100%" />
                </linearGradient>
                <filter
                    x="-44.4%"
                    y="-87.5%"
                    width="188.9%"
                    height="300%"
                    filterUnits="objectBoundingBox"
                    id="prefix_three__a"
                >
                    <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur
                        stdDeviation={2.5}
                        in="shadowOffsetOuter1"
                        result="shadowBlurOuter1"
                    />
                    <feColorMatrix
                        values="0 0 0 0 0 0 0 0 0 0.439215686 0 0 0 0 1 0 0 0 0.2 0"
                        in="shadowBlurOuter1"
                    />
                </filter>
                <filter
                    x="-46.2%"
                    y="-36.1%"
                    width="192.4%"
                    height="182.6%"
                    filterUnits="objectBoundingBox"
                    id="prefix_three__e"
                >
                    <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur
                        stdDeviation={2.5}
                        in="shadowOffsetOuter1"
                        result="shadowBlurOuter1"
                    />
                    <feColorMatrix
                        values="0 0 0 0 0 0 0 0 0 0.439215686 0 0 0 0 1 0 0 0 0.2 0"
                        in="shadowBlurOuter1"
                    />
                </filter>
                <filter
                    x="-43.8%"
                    y="-14.7%"
                    width="187.5%"
                    height="141.2%"
                    filterUnits="objectBoundingBox"
                    id="prefix_three__h"
                >
                    <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur
                        stdDeviation={1}
                        in="shadowOffsetOuter1"
                        result="shadowBlurOuter1"
                    />
                    <feColorMatrix
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.257730551 0"
                        in="shadowBlurOuter1"
                    />
                </filter>
                <path
                    d="M7.38 14.016l3.636 3.636-4.364 4.364-.91-2.726-2.726-.91 4.364-4.364zm9.272 0l4.364 4.364-2.726.91-.91 2.726-4.364-4.364 3.636-3.636z"
                    id="prefix_three__b"
                />
                <path
                    d="M9.66.593l6.66 3.845a2 2 0 011 1.732v7.69c0 .716-.381 1.376-1 1.733l-6.66 3.846a2.001 2.001 0 01-2 0L1 15.594a2 2 0 01-1-1.732V6.17c0-.715.381-1.375 1-1.732L7.66.593a2.001 2.001 0 012 0z"
                    id="prefix_three__d"
                />
                <text
                    id="prefix_three__i"
                    fontFamily="PingFangSC-Medium, PingFang SC"
                    fontSize={12}
                    fontWeight={400}
                >
                    <tspan x={5.044} y={14}>
                        {'3'}
                    </tspan>
                </text>
            </defs>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <g>
                    <use fill="#000" filter="url(#prefix_three__a)" xlinkHref="#prefix_three__b" />
                    <use fill="url(#prefix_three__c)" xlinkHref="#prefix_three__b" />
                </g>
                <g transform="translate(3.356 1)">
                    <mask id="prefix_three__g" fill="#fff">
                        <use xlinkHref="#prefix_three__d" />
                    </mask>
                    <use fill="#000" filter="url(#prefix_three__e)" xlinkHref="#prefix_three__d" />
                    <use fill="url(#prefix_three__f)" xlinkHref="#prefix_three__d" />
                    <g fillRule="nonzero" mask="url(#prefix_three__g)">
                        <use fill="#FFF" filter="url(#prefix_three__h)" xlinkHref="#prefix_three__i" />
                        <use fill="url(#prefix_three__j)" xlinkHref="#prefix_three__i" />
                        <use fill="#FFF" xlinkHref="#prefix_three__i" />
                    </g>
                    <path
                        d="M11.032 2.16c2.205 2.262 3.081 4.959 2.628 8.09-.583 4.028-3.557 8.103-8.516 8.682 6.167 1.894 11.682 1.394 16.546-1.5L19.931 3.34 15.16-9 11.032 2.16z"
                        fill="url(#prefix_three__k)"
                        opacity={0.4}
                        mask="url(#prefix_three__g)"
                    />
                </g>
            </g>
        </svg>
    );
}

export default TopThree;
